import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import Modal from "react-modal";
// import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import { ScrollableComponentElement } from "scrollable-component";
import { BodyBuilder } from "../../../exports/Images";
import { createLog } from "../../../redux/reducers/postApiSlice";
import { toast } from "react-toastify";
import { fetchAllPastDiscussionLogsData } from "../../../redux/reducers/apiSlice";
import moment from "moment";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { selectAuth } from "../../auth/auth.selector";

const Discussions = ({ discussionModalData }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { discussionLogsData } = useSelector((state) => state.api);
  const [discussions, setDiscussions] = useState("");
  const [allDiscussionLogsData, setAllDiscussionLogsData] = useState([]);
  const [discussionBriefModal, setDiscussionBriefModal] = useState(false);
  const [briefMessage, setBriefMessage] = useState("");

  const handleCreateLog = async (userData, TOKEN) => {
    try {
      const result = await dispatch(createLog({ userData, TOKEN }));

      if (createLog.fulfilled.match(result)) {
        setDiscussions("");
        dispatch(
          fetchAllPastDiscussionLogsData({
            discussionId:
              discussionModalData?.discussionId ||
              discussionModalData?.discussionData?.discussion_id,
            token: decryptedText?.token,
          })
        );
      } else {
        const errorMessage = result.error.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleCreateLog ERROR => ", error);
    }
  };

  const onClickUpdate = (e) => {
    if (!discussions) {
      toast.error("Please enter some text");
      return;
    }
    const userData = {
      discussion_id:
        discussionModalData?.discussionId ||
        discussionModalData?.discussionData?.discussion_id,
      message: discussions,
      staff_id: decryptedText?.user_id || decryptedText?.uid,
      // staff_id: "JvXw3FgDE9OWm",
    };

    const payload = JSON.stringify(userData);

    handleCreateLog(payload, decryptedText?.token);
  };

  useEffect(() => {
    dispatch(
      fetchAllPastDiscussionLogsData({
        discussionId:
          discussionModalData?.discussionId ||
          discussionModalData?.discussionData?.discussion_id,
        token: decryptedText?.token,
      })
    );
  }, [
    discussionModalData?.discussionId,
    discussionModalData?.discussionData?.discussion_id,
  ]);

  useEffect(() => {
    if (discussionLogsData?.status && discussionLogsData?.data) {
      setAllDiscussionLogsData(discussionLogsData?.data?.logsHistory);
    }
  }, [discussionLogsData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="formContainer">
      {/* <ToastContainer /> */}
      <Modal
        isOpen={discussionBriefModal}
        onRequestClose={() => setDiscussionBriefModal(false)}
        contentLabel="Discussion Brief Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer discussionModalBriefContainer">
          <ModalHeadAndClose
            title=" "
            onClose={() => setDiscussionBriefModal(false)}
          />
          <div className="discussionModalMessage">
            <p className="message">{briefMessage || "N/A"}</p>
          </div>
        </div>
      </Modal>

      <div className="profileInfo">
        <div className="profileImage">
          <img
            src={discussionModalData?.discussionData?.profile || BodyBuilder}
            alt={discussionModalData?.discussionData?.trainer_name || "N/A"}
            className="profile"
          />
        </div>

        <div className="profileDetails">
          <p className="name">
            {discussionModalData?.discussionData?.name || "N/A"}
          </p>
          <p className="subName">
            {discussionModalData?.discussionData?.gym_name || "N/A"}
          </p>
          <p className="designation">
            Trainer -{" "}
            <span className="designatorName">
              {discussionModalData?.discussionData?.trainer_name || "N/A"}
            </span>
          </p>
          {!discussionModalData?.discussionData?.checked_in_status && (
            <p className="checkedInStatus">member not checked in</p>
          )}
        </div>
      </div>

      {discussionModalData?.discussionData?.checked_in_status ? (
        <div className="addDiscussionInputContainer">
          <p className="discussionTag">Add discussion</p>
          <div className="inputContainer">
            <textarea
              className="inputBox"
              placeholder="Write brief description about your discussion"
              value={discussions}
              onChange={(e) => setDiscussions(e.target.value)}
            ></textarea>

            <div className="buttonContainer">
              <Button
                className="saveBtn"
                variant="danger"
                onClick={onClickUpdate}
              >
                Update
              </Button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="pastDiscussionContainer">
        <p className="pastDiscussionTag">Past Discussion</p>

        {allDiscussionLogsData?.length > 0 ? (
          <scrollable-component className="my-content">
            <div className="scrollablePastDiscussion">
              {allDiscussionLogsData?.map((dis, index) => (
                <>
                  <div className="allFeedbacksCard">
                    <div className="feedbackCard">
                      <div className="contentBox">
                        <p className="content">
                          {dis?.date_added
                            ? moment(dis.date_added, "YYYY-MM-DD HH:mm")
                                .tz("Asia/Kolkata")
                                .format("DD-MM-YYYY hh:mm A")
                            : "-"}
                        </p>
                        <span className="subContent">Date</span>
                      </div>
                    </div>
                    <div className="feedbackCard">
                      <div className="contentBox">
                        <p className="content">
                          {dis?.message?.length > 50
                            ? `${dis.message.substring(0, 50)}...`
                            : dis?.message || "-"}
                        </p>
                        {dis?.message?.length > 50 && (
                          <button
                            onClick={() => {
                              setBriefMessage(dis.message);
                              setDiscussionBriefModal(true);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-arrow-down-short"
                              viewBox="0 0 16 16"
                              style={{ fontSize: "15px", color: "gray" }}
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                              />
                            </svg>

                            {/* <MdKeyboardDoubleArrowDown
                              className="icon"
                              style={{ fontSize: "15px", color: "gray" }}
                            /> */}
                          </button>
                        )}
                        <span className="subContent">Discussion</span>
                      </div>
                    </div>
                    <div className="feedbackCard">
                      <div className="contentBox">
                        <p className="content">
                          {`${dis?.discussion_started_by_name} (${dis?.account_type})` ||
                            "-"}
                        </p>
                        <span className="subContent">
                          DIscussion Started By
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="grayLine"></div>
                </>
              ))}
            </div>
          </scrollable-component>
        ) : (
          <span className="errorMessage">No Past Discussion Found</span>
        )}
      </div>
    </div>
  );
};

export default Discussions;
